import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
    width: '15em',
    marginLeft: '3.9em',
    marginTop: '0.5em',
    color: 'black'
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

export default function SelectButton(props) {
  const { items, onClick, title } = props
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    if(items) {
      setAnchorEl(event.currentTarget);
    } else  {
      onClick && onClick()
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        aria-controls="customized-menu"
        aria-haspopup="true"
        variant="contained"
        color="primary"
        onClick={handleClick}
      >
        {title}
      </Button>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {items && items.map((item, index) => <StyledMenuItem key={index} 
            onClick={() => {
                setAnchorEl(null);
                onClick && onClick(item.value || item)
            }}>
          {/* <ListItemIcon>
            <SendIcon fontSize="small" />
          </ListItemIcon> */}
          <ListItemText primary={item.title} />
        </StyledMenuItem>)}
      </StyledMenu>
    </div>
  );
}